/**
 * Future welcome-deposit campaign. Phase A: catalog/UI only.
 * Do not credit REAL/BONUS or grant free spins from this module.
 */
export const WELCOME_DEPOSIT_CAMPAIGN = {
  plannedCode: 'WELCOME_275_FS250',
  title: '275% kazino bonusu + 250 FS',
  percentBps: 27500,
  minDepositMinor: 1000,
  oncePerPlayer: true,
  creditWallet: 'bonus' as const,
  grantOn: 'first_approved_deposit' as const,
  grantOnRegister: false,
  freeSpins: 250,
  freeSpinsReady: false,
  listedForPlayers: false,
} as const;

export interface ListedCampaign {
  code: string;
  campaign_type: string;
  title: string;
}

/** Only server-listed campaigns may appear as selectable. Planned copy is never injected. */
export function selectableCampaigns(rows: ListedCampaign[] | null | undefined): ListedCampaign[] {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => row.code && row.title);
}
